import styles from './Invoice.module.scss'
import { MailLink } from './MailLink'
const RevisionLink = ({ invoiceDetails }) => {
  const { subsidiaryName, subsidiaryInvoiceId } = invoiceDetails

  return (
    <p className={styles.revisionLink}>
      If you have any concerns regarding this invoice, please feel free to reach out to
      us. You can email us at {` `}
      <MailLink invoiceId={subsidiaryInvoiceId} hotelName={subsidiaryName} /> <br /> or
      give us a call at <a href="tel:+16504497321">+1 (650) 449-7321</a>. Additionally, if
      you need to access our W9 form, you download it from{' '}
      <a href="https://directful.com/w9" target="_blank" rel="noreferrer">
        directful.com/w9
      </a>
      .
    </p>
  )
}

export default RevisionLink
